import React from 'react';
import RoleMaintenanceRouter from './RoleMaintenanceRouter';

export default function RoleMaintenancePage() {
  return <RoleMaintenanceRouter />;
}
